import { RouterState } from 'connected-react-router';
import { ApplicationFormState } from './applicationForm';

export enum FundTypes {
  CapitalConservative = 'CapitalConservative',
  CapitalBalanced = 'CapitalBalanced',
  CapitalUnconstrained = 'CapitalUnconstrained',
  DigitalConservative = 'DigitalConservative',
  DigitalBalanced = 'DigitalBalanced',
  DigitalUnconstrained = 'DigitalUnconstrained'
}

interface ToolStateI {
  duration: number,
  lumpSum: number,
  monthlyContribution: number,
  capitalFund: FundTypes | null,
  digitalFund: FundTypes | null,
  allocation: number,
  graphFilter: GraphFilters,
  graphData: GraphData,
  highCaseOutcome: number,
  lowCaseOutcome: number,
  mediumCaseOutcome: number
}

interface SignUpStateI {
  signUpError: string,
  hasSubmitted: boolean
}

interface WalkthroughStateI {
  isComplete: boolean
}

interface AppStateI {
  tool: ToolState,
  walkthrough: WalkthroughState,
  signUp: SignUpState,
  applicationForm: ApplicationFormState,
  router: RouterState
}

interface FundI {
  name: FundTypes,
  allocation: number
}

export enum GraphFilters {
  Blend = 'Blend',
  Digital = 'Digital',
  Capital = 'Capital'
}

type InvestmentI = Fund[];

interface InterestMapI {
  [key: string]: InterestRates;
}

interface InterestRatesI {
  high: number,
  low: number,
  medium: number
}

interface PeriodI extends InterestRates {
  xaxis: string
};

type GraphDataI = Period[];

interface SignUpInfoI {
  name: string,
  email: string,
}

interface SignUpInfoWithResultsI extends SignUpInfo {
  simulatorResults: ToolState
}

interface RAQuestionnaireI {
  questions: RAQuestion[]
}

interface RAQuestionI {
  id: number,
  text: string,
  answers: RAAnswer[]
}

interface RAAnswerI {
  id: number,
  text: string
}

export type AppState = AppStateI
export type SignUpState = SignUpStateI
export type ToolState = ToolStateI
export type WalkthroughState = WalkthroughStateI
export type GraphData = GraphDataI
export type Period = PeriodI
export type InterestRates = InterestRatesI
export type InterestMap = InterestMapI
export type Fund = FundI
export type Investment = InvestmentI
export type SignUpInfo = SignUpInfoI
export type SignUpInfoWithResults = SignUpInfoWithResultsI
export type RAQuestionnaire = RAQuestionnaireI
export type RAQuestion = RAQuestionI
export type RAAnswer = RAAnswerI
